/**
 * Per-status badge theme, per the design spec's colour ruling: Idée/montage = gris,
 * En cours = violet, Suspendu = orange, Clôturé = vert, Archivé = gris foncé.
 * Shared by the projects list and the project record header so the mapping lives in one place.
 */
export const projectStatusTheme = {
    Idea: "neutral",
    InProgress: "violet",
    Suspended: "orange",
    Closed: "green",
    Archived: "dark",
};
